import { AppColors } from "@/styles/colors";

  export const historyScrollAreaCss = {
    "@media (max-width: 1350px) and (min-width: 1272px)": {
      maxWidth: "100%",
      height: "140px",
    },
    "@media (max-width: 1414px) and (min-width: 1351px)": {
      maxWidth: "100%",
      height: "210px",
    },
    "@media (max-width: 1590px) and (min-width: 1415px)": {
      maxWidth: "100%",
      height: "280px",
    },
    "@media (max-width: 1696px) and (min-width: 1591px)": {
      maxWidth: "100%",
      height: "320px",
    },
    "@media (max-width: 1900px)": {
      maxWidth: "100%",
      height: "420px",
    },
    "@media (min-width: 1901px)": {
      height: "420px",
    },
  } as const;

  export const uploadBoxCss = {
    "@media (max-width: 1350px) and (min-width: 1272px)": {
      maxWidth: "900px",
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "24px",
      paddingBottom: "24px",
    },
    "@media (max-width: 1414px) and (min-width: 1351px)": {
      maxWidth: "1100px",
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "28px",
      paddingBottom: "28px",
    },
    "@media (max-width: 1590px) and (min-width: 1415px)": {
      maxWidth: "1250px",
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "32px",
      paddingBottom: "32px",
    },
    "@media (max-width: 1696px) and (min-width: 1591px)": {
      maxWidth: "1350px",
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "36px",
      paddingBottom: "36px",
    },
    "@media (max-width: 1900px)": {
      maxWidth: "1500px",
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "40px",
      paddingBottom: "40px",
    },
    "@media (min-width: 1901px)": {
      maxWidth: "1500px",
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "40px",
      paddingBottom: "40px",
    },
  } as const;

  export const uploadAnotherButtonProps = {
    variant: "outline" as const,
    paddingX: "16px",
    borderRadius: "8px",
    borderColor: AppColors.BLACK_TEXT_SECONDARY,
    color: AppColors.BLACK_TEXT_SECONDARY,
    bgColor: AppColors.WHITE_SECONDARY,
    _hover: { bgColor: AppColors.BACKGROUND_SECONDARY },
    _active: { bgColor: AppColors.BACKGROUND_SECONDARY },
  };